import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../context/AuthContext';
import { requestDevice } from '../../../api/ownerTelematics';

const BENEFITS = ['liveLocation', 'drivingScore', 'crashProtection', 'insuranceDiscount'];

export default function NoDeviceUpsell({ vehicleId }) {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [state, setState] = useState('idle'); // idle | sending | sent | error

  const onRequest = async () => {
    setState('sending');
    try {
      await requestDevice(vehicleId, token);
      setState('sent');
    } catch (e) {
      setState('error');
    }
  };

  return (
    <div className="rounded-xl border-2 border-blue-200 bg-white p-5">
      <h3 className="text-base font-semibold text-blue-700">{t('ownerTelematics.upsell.title')}</h3>
      <ul className="mt-2 space-y-1 text-sm text-gray-700">
        {BENEFITS.map((b) => <li key={b}>• {t(`ownerTelematics.upsell.benefits.${b}`)}</li>)}
      </ul>
      {state === 'sent' ? (
        <p className="mt-3 text-sm font-medium text-green-600">{t('ownerTelematics.upsell.sent')}</p>
      ) : (
        <button onClick={onRequest} disabled={state === 'sending'}
          className="mt-3 rounded-lg bg-blue-600 px-4 py-2 text-sm text-white disabled:opacity-50">
          {state === 'sending' ? t('common.loading') : t('ownerTelematics.upsell.cta')}
        </button>
      )}
      {state === 'error' && <p className="mt-2 text-sm text-red-600">{t('ownerTelematics.upsell.error')}</p>}
    </div>
  );
}
